/**
 * PDFPresentationControls - Controls for presentation mode
 *
 * Extracted from PDFViewerModal.tsx
 */

import React from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import type { Theme } from '../../../themes/theme';

export interface PDFPresentationControlsProps {
  theme: Theme;
  pageNumber: number;
  numPages: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onExit: () => void;
}

export function PDFPresentationControls({
  theme,
  pageNumber,
  numPages,
  onPreviousPage,
  onNextPage,
  onExit,
}: PDFPresentationControlsProps) {
  return (
    <div
      className={`absolute bottom-4 left-1/2 transform -translate-x-1/2 ${theme.colors.bg.primary} border ${theme.colors.border.primary} rounded-lg shadow-lg p-2 flex items-center gap-2 z-30`}
    >
      <button
        onClick={onPreviousPage}
        disabled={pageNumber <= 1}
        className={`p-2 ${theme.colors.text.secondary} hover:${theme.colors.text.primary} ${theme.colors.state.hover} rounded transition-colors disabled:opacity-50`}
        title="Página anterior"
      >
        <ChevronLeft size={18} />
      </button>
      <span className={`text-sm ${theme.colors.text.primary} min-w-[80px] text-center font-medium`}>
        {pageNumber}/{numPages}
      </span>
      <button
        onClick={onNextPage}
        disabled={pageNumber >= numPages}
        className={`p-2 ${theme.colors.text.secondary} hover:${theme.colors.text.primary} ${theme.colors.state.hover} rounded transition-colors disabled:opacity-50`}
        title="Página siguiente"
      >
        <ChevronRight size={18} />
      </button>
      <div className="h-6 w-px bg-nb-border mx-1" />
      <button
        onClick={onExit}
        className={`p-2 ${theme.colors.text.secondary} hover:${theme.colors.text.primary} ${theme.colors.state.hover} rounded transition-colors`}
        title="Salir de modo presentación"
      >
        <X size={18} />
      </button>
    </div>
  );
}
